import styled from '@emotion/styled';
import { tooltip } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

type TooltipStyledProps = {
  direction?: 'right' | 'left';
};

export const TooltipStyled = styled('div', { label: 'TooltipStyled' })`
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: fit-content;

  &:hover .tooltip-content {
      visibility: visible;
  }
`;

export const TooltipContent = styled('div', { label: 'TooltipContent' })<TooltipStyledProps>`
    position: absolute;
    top: 28px;
    ${({ direction }): string => direction === 'left' ? '' : 'right: -16px'};
    width: max-content;
    background: ${tooltip.bgColor};
    color: ${tooltip.txtColor};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.medium}; // TODO: ADD 600
    padding: 8px;
    border-radius: 4px;
    box-shadow: inset 0px 0px 0px 1px ${tooltip.borderColor};
    z-index: 1;
    visibility: hidden;

    &::after {
        content:'';
        position: absolute;
        top: -4px;
        ${({ direction }): string => direction === 'left' ? 'left:30px' : 'right: 30px'};
        width: 8px;
        height: 8px;
        background:inherit;
        transform:rotate(45deg);
        box-shadow: inset 5px 5px 0px -4px ${tooltip.borderColor};
    }
`;
